import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { ILotPlanModel, LotPlanModel } from '../models/veg-wizard-models';

@Injectable({
  providedIn: 'root'
})
export class LotPlanService {

  constructor(private http: HttpClient, private sessionService: SessionService) {
  }

  getLotPlan$(lot: string, plan: string): Observable<ILotPlanModel> {
    if (!lot || !plan) { return of(); }

    lot = lot.trim();
    plan = plan.trim();
    const sessionId = this.sessionService.getSessionIdOrError();

    const lotOnPlan =
      {
        lot,
        plan,
        sessionKey: sessionId
      } as LotPlanModel;

    return this.setLotOnPlan$(lotOnPlan).pipe(
      map((lotOnPlanResult: ILotPlanModel) => {
        lotOnPlanResult.lot = lot;
        lotOnPlanResult.plan = plan;
        return lotOnPlanResult;
      }));

  }

  private setLotOnPlan$(lotPlanModel: LotPlanModel): Observable<ILotPlanModel> {
    const url = `${environment.apiUrl}/session/set-lot-on-plan/`
    return this.http.post<ILotPlanModel>(url, lotPlanModel);
  }
}
